import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../../Base/Components/Inputs/BaseField/BaseField';
import InsuranceOperationSelect from './InsuranceOperationSelect';

interface Props extends BaseFieldProps {
	insuranceId: string;
}
const InsuranceOperationSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<InsuranceOperationSelect insuranceId={props.insuranceId} />
	</BaseField>
);

export default InsuranceOperationSelectField;
